import {
  FETCH_DS1_PRODUCT_LIST,
  RESET_DS1_PRODUCT_LIST,
} from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const ds1ProductListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DS1_PRODUCT_LIST:
      return { list: action.payload, others: action.others };
    case RESET_DS1_PRODUCT_LIST: {
      return initialState;
    }
    default:
      return state;
  }
};

export default ds1ProductListReducer;
